<po-page-edit
  p-title="Pré-cadastro Produto PDM"
  [p-breadcrumb]="breadcrumb"
>
  <form #formPrincipal="ngForm">
    <po-widget class="po-sm-12 po-md-12 po-lg-12"
      p-title="Informações do Produto - Solicitante"
    >
      <po-combo class="po-sm-12 po-md-4"
        name="CGRPNVL1"
        p-label="Grupo Nvl 1"
        [(ngModel)]="preProdutoPdm.CGRPNVL1"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc0"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        (p-change)="onChangeNvl1()"
        p-change-on-enter="true"
      ></po-combo>

      <po-combo class="po-sm-12 po-md-4"
        name="CGRPNVL2"
        p-label="Grupo Nvl 2"
        [(ngModel)]="preProdutoPdm.CGRPNVL2"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc1"
        [p-filter-params]="filterZC1"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante || preProdutoPdm.CGRPNVL1 == ''"
        (p-change)="onChangeNvl2()"
        p-change-on-enter="true"
      ></po-combo>

      <po-combo class="po-sm-12 po-md-4"
        name="CB1XPDM"
        p-label="PDM"
        [(ngModel)]="preProdutoPdm.CB1XPDM"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc2"
        [p-filter-params]="filterZC2"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante || preProdutoPdm.CGRPNVL2 == ''"
        (p-change)="onChangePDM()"
        p-change-on-enter="true"
      ></po-combo>

      @if (caracteristicas.controls.length) {
        <po-widget class="po-md-12">
          <form [formGroup]="caracteristicasForm">
            <div formArrayName="items" class="po-md-12 po-p-0">
              <div class="po-md-1"><b>Sequência</b></div>
              <div class="po-md-4"><b>Caracteristica</b></div>
              <div class="po-md-4"><b>Item</b></div>
              <div *ngFor="let caracteristica of caracteristicas.controls; let i=index">
                <div [formGroupName]="i" class="po-md-12 po-p-0">
                  <po-input
                    class="po-md-1"
                    name="sequencia"
                    [p-disabled]="true"
                    formControlName="CSEQUENCIA"
                  ></po-input>
                  <po-input
                    class="po-md-4"
                    name="caracteristica"
                    [p-disabled]="true"
                    formControlName="CCARACTERISTICA"
                  ></po-input>
                  @if(caracteristicas.value[i].CMODO != 'D') {
                  <po-combo class="po-md-4"
                    name="item"
                    p-icon="po-icon-search"
                    p-field-label="CZC4DESCL"
                    p-field-value="CZC4COD"
                    p-filter-service="{{urlApiProtheus}}/wsrpdm/zc4"
                    [p-filter-params]="filterZC4[i]"
                    p-disabled-init-filter="false"
                    p-infinite-scroll="true"
                    formControlName="CITEM"
                    p-emit-object-value="true"
                    (p-change)="onChangeCaracteristica(i)"
                    p-change-on-enter="true"
                    [p-disabled]="bloqueiaDadosSolicitante"
                  ></po-combo>
                  } @else {
                  <po-input class="po-md-4"
                    name="itemDesc"
                    formControlName="CITEM"
                    (p-change)="onChangeCaracteristica(i)"
                    p-change-on-enter="true"
                    [p-disabled]="bloqueiaDadosSolicitante"
                    p-maxlength="20"
                  ></po-input>
                  }
                </div>
              </div>
            </div>
          </form>
        </po-widget>
      }

      <po-input class="po-sm-12 po-md-5"
        name="CB1DESC"
        p-label="Descrição Curta"
        [(ngModel)]="preProdutoPdm.CB1DESC"
        p-required="true"
        [p-disabled]="true"
        p-clean="true"
        p-maxlength="80"
      ></po-input>

      <po-input class="po-sm-12 po-md-7"
        name="CB1XDESCL"
        p-label="Descrição Longa"
        [(ngModel)]="preProdutoPdm.CB1XDESCL"
        p-required="true"
        [p-disabled]="true"
        p-clean="true"
        p-maxlength="250"
      ></po-input>

      <po-combo class="po-sm-12 po-md-6 po-lg-6"
        name="CB1POSIPI"
        p-label="NCM"
        [(ngModel)]="preProdutoPdm.CB1POSIPI"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc6"
        [p-filter-params]="filterPDMCombo"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>

      <po-combo class="po-sm-6 po-md-4 po-lg-2"
        name="CB1UM"
        p-label="Unidade Medida"
        [(ngModel)]="preProdutoPdm.CB1UM"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc8"
        [p-filter-params]="filterPDMCombo"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-combo>

      <po-combo class="po-sm-6 po-md-4 po-lg-2"
        name="CB1SEGUM"
        p-label="Segunda Unidade Medida"
        [(ngModel)]="preProdutoPdm.CB1SEGUM"
        p-filter-service="{{urlApiProtheus}}/wsrpdm/zc8"
        [p-filter-params]="filterPDMCombo"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-combo>

      @if(preProdutoPdm.CB1SEGUM) {
        <po-decimal class="po-sm-6 po-md-3 po-lg-2"
          name="NB1CONV"
          p-label="Fator de Conversão de UM"
          [(ngModel)]="preProdutoPdm.NB1CONV"
          p-maxlength="12"
          p-min="0.00000001"
          p-decimals-length="8"
          p-thousand-maxlength="3"
          [p-disabled]="bloqueiaDadosSolicitante">
        </po-decimal>
      }

      <po-select class="po-sm-6 po-md-3 po-lg-2"
        name="CB1MRP"
        p-label="Controle de Estoque?"
        [(ngModel)]="preProdutoPdm.CB1MRP"
        [p-options]="[
          {value: 'S', label: 'Sim'},
          {value: 'N', label: 'Não'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>

      @if (preProdutoPdm.CB1MRP === 'S' ) {
        <po-decimal class="po-sm-4 po-md-3 po-lg-2"
          name="NB1EMIN"
          p-label="Estoque Mínimo"
          [(ngModel)]="preProdutoPdm.NB1EMIN"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-decimals-length="0"
          p-clean="true"
        ></po-decimal>

        <po-decimal class="po-sm-4 po-md-3 po-lg-2"
          name="NB1EMAX"
          p-label="Estoque Máximo"
          [(ngModel)]="preProdutoPdm.NB1EMAX"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-decimals-length="0"
          p-clean="true"
        ></po-decimal>
      }

      <po-combo class="po-sm-12 po-md-4"
        name="CSETOR"
        p-label="Setor"
        [(ngModel)]="preProdutoPdm.CSETOR"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/ctt"
        [p-filter-params]="{combobox:'S', setor:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-combo>
    </po-widget>
    @if ( !bloqueiaDadosCompras || !bloqueiaDadosControladoria ) {
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Informações do Produto - Compras"
      >
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1GRUPO"
          p-label="Grupo"
          [(ngModel)]="preProdutoPdm.CB1GRUPO"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/grupo"
          [p-filter-params]="{combobox:'S',CBMCLASOL: '5'}"
          (p-change)="onChangeGrupo()"
          p-change-on-enter="true"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1LOCPAD"
          p-label="Local Padrão"
          [(ngModel)]="preProdutoPdm.CB1LOCPAD"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/armazem"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XFAM"
          p-label="Família Estrutural"
          [(ngModel)]="preProdutoPdm.CB1XFAM"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/familia"
          [p-filter-params]="filterZAN"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras || preProdutoPdm.CB1GRUPO == ''"
          p-clean="true"
        ></po-combo>

      </po-widget>
    }
    @if ( !bloqueiaDadosControladoria ) {
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Informações do Produto - Controladoria"
      >
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1TIPO"
          p-label="Tipo"
          [(ngModel)]="preProdutoPdm.CB1TIPO"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrbase/sx5/02"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1CONTA"
          p-label="Conta Estoque"
          [(ngModel)]="preProdutoPdm.CB1CONTA"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTACUS"
          p-label="Conta de Custo"
          [(ngModel)]="preProdutoPdm.CB1XCTACUS"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTADEA"
          p-label="Conta Despesa Administrativa"
          [(ngModel)]="preProdutoPdm.CB1XCTADEA"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTADEC"
          p-label="Conta Despesa Compras"
          [(ngModel)]="preProdutoPdm.CB1XCTADEC"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1TE"
          p-label="TE (tipo de entrada padrão)"
          [(ngModel)]="preProdutoPdm.CB1TE"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrtes"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XTPSPED"
          p-label="Tipo SPED"
          [(ngModel)]="preProdutoPdm.CB1XTPSPED"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrbase/sx5/ZS"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
      </po-widget>
    }
    @if (liberaAvancarProcesso){
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Outras informações técnicas importantes"
      >
        <po-textarea class="po-sm-12 po-md-12 po-lg-12"
          name="OBSERVACAO"
          [(ngModel)]="historico"
          p-rows="4"
          p-required="true"
          p-minlength="10"
        ></po-textarea>
        <po-button class="po-sm-4 po-md-4 po-lg-4"
          p-label="Encerrar Processo"
          p-danger="true"
          p-kind="primary"
          [p-disabled]="!usuarioEngenharia || !usuarioCompras || !usuarioControladoria"
          (p-click)="encerrarProcesso()"
        ></po-button>
        <po-button class="po-sm-4 po-md-4 po-lg-4"
          p-label="{{ [' ','2'].includes(processoCadastro.CSTATUS) ? 'Cancelar' : 'Recusar' }} Processo"
          p-danger="true"
          (p-click)="cancelarRecusarTela()"
        ></po-button>
        <po-button class="po-sm-4 po-md-4 po-lg-4"
          p-label="Avançar Processo"
          p-kind="primary"
          (p-click)="confirmarTela()"
        ></po-button>
      </po-widget>
    }
  </form>
  <po-divider class="po-row" class="po-md-12 po-mt-2" p-label="Anexos"></po-divider>
  <po-button class="po-sm-12 po-md-12 po-lg-12"
    p-label="Imagens"
    p-icon="po-icon-picture"
    (p-click)="arquivosLoadDados()"
  ></po-button>
  <po-divider class="po-row" class="po-md-12 po-mt-2" p-label="Histórico do Processo"></po-divider>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-items]="tabelaHistorico"
    [p-columns]="tabelaHistoricoColunas"
    p-container="true"
    p-spacing="small"
    p-hide-columns-manager="true"
  ></po-table>
</po-page-edit>

<po-page-slide #anexoPageSlide
  p-title="Anexos"
  p-size="xl"
  p-click-out="true">
  <app-util-arquivo #utilArquivo [podeExcluir]="false" [habilitaUpload]="bloqueiaDadosControladoria"></app-util-arquivo>
</po-page-slide>
